// extracted by mini-css-extract-plugin
export default {"Container":"CommitsStatus_Container__6hNsE","FirstRow":"CommitsStatus_FirstRow__r6gvV"};